module.exports = __webpack_public_path__ + "static/media/dairy_and_eggs@3x.9675d9d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dairy_and_eggs@3x.png
// module id = 771
// module chunks = 1